import { Component, OnInit } from '@angular/core';
import { GamesGroupService, GroupType, PredictorGroupSummary } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-predictor-play',
  templateUrl: 'predictor-play.component.html',
  styleUrl: './predictor-page.component.scss',
})
export class PredictorPlayComponent implements OnInit {
  gamesGroup$: Observable<PredictorGroupSummary[]>;
  groupType = GroupType.Predictor;
  constructor(private gamesGroupService: GamesGroupService) {}
  ngOnInit(): void {
    this.gamesGroup$ = this.gamesGroupService.fetchPredictorGroups();
  }
}

@Component({
  selector: 'fgb-predictor-page',
  templateUrl: './predictor-page.component.html',
  styleUrl: './predictor-page.component.scss',
})
export class PredictorPageComponent {
  ngOnInit(): void {}
}